module.exports = __webpack_public_path__ + "static/media/golf.ea4921a8.png";